import styled from 'styled-components/native';

import { ErrorText } from 'components/Text/ErrorText';

const Wrapper = styled.View``;

export { ErrorText, Wrapper };
